/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Hub_Meta_ReadyInputs */

const cs_social_hub_meta_ready = /** @type {(inputs: Social_Hub_Meta_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připraveno k publikaci`)
};

const en_social_hub_meta_ready = /** @type {(inputs: Social_Hub_Meta_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready to publish`)
};

/**
* | output |
* | --- |
* | "Ready to publish" |
*
* @param {Social_Hub_Meta_ReadyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_hub_meta_ready = /** @type {((inputs?: Social_Hub_Meta_ReadyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Hub_Meta_ReadyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_hub_meta_ready(inputs)
	return cs_social_hub_meta_ready(inputs)
});